import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { styled } from 'styled-components'

// Layout wrapper for a fe-core `<Tag>`'s children when the tag needs an icon
// glyph next to its label. fe-core's Tag has no built-in icon slot, so the
// caller composes `<TagWithIcon><TagIcon icon={...} /><label /></TagWithIcon>`
// inside the Tag's children. Kept as its own module so all tag icon glyphs
// across the app render at a consistent size and spacing.
export const TagWithIcon = styled.span`
  align-items: center;
  display: inline-flex;
  gap: 0.25rem;
  vertical-align: middle;
`

export const TagIcon = styled(FontAwesomeIcon)`
  flex-shrink: 0;
  height: 0.75rem;
  width: 0.75rem;
`
